import { configureStore } from '@reduxjs/toolkit'
import hcpReducer from './reducers/hcpSlice'

export default configureStore({
  reducer: hcpReducer,
})